import React, { Component } from "react";

export default function(ComposedComponent, tabUrlId) {
  return class extends Component {
    render() {
      return <ComposedComponent activeTabUrlId={tabUrlId} {...this.props} />;
    }
  };
}
